import {Form} from 'formsy-semantic-ui-react'
import * as R from 'ramda'
import React from 'react'
import ThaiAddress from 'react-thai-address'
import {Button, Label} from 'semantic-ui-react'

const countryOptions = [
    {key: 'th', value: 'Thailand', flag: 'th', text: 'ประเทศไทย'}
]

class MailingAddressPresentation extends React.Component {
    state = {canSubmit: false}

    disableButton = () => {
        this.setState({canSubmit: false})
    }

    enableButton = () => {
        this.setState({canSubmit: true})
    }

    generateAddressOption = elements => {
        const result = []
        elements.forEach(element =>
            result.push({
                key: element,
                text: element,
                value: element
            })
        )
        return result
    }

    render() {
        const {
            handleChange,
            firstname,
            lastname,
            handleAddressSelect,
            address_1,
            sub_district,
            district,
            province,
            country,
            phone_number,
            showPhoneNumber,
            postal_code
        } = this.props
        const errorLabel = <Label color="red" pointing/>
        return (
            <React.Fragment>
                <Form
                    id="mailing"
                    onValidSubmit={this.props.onClickNext}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                >
                    <Form.Group widths="2">
                        <Form.Input
                            required
                            name="firstname"
                            value={firstname}
                            icon="user"
                            iconPosition="left"
                            validationErrors={{
                                isDefaultRequiredValue: 'โปรดกรอกชื่อจริง'
                            }}
                            placeholder="กรุณาระบุชื่อจริง"
                            onChange={handleChange}
                            errorLabel={errorLabel}
                        />
                        <Form.Input
                            required
                            name="lastname"
                            value={lastname}
                            icon="user"
                            iconPosition="left"
                            validationErrors={{
                                isDefaultRequiredValue: 'โปรดกรอกนามสกุลจริง'
                            }}
                            placeholder="กรุณาระบุนามสกุลจริง"
                            onChange={handleChange}
                            errorLabel={errorLabel}
                        />
                    </Form.Group>
                    {showPhoneNumber && (
                        <Form.Group widths="equal" style={{marginTop: 15}}>
                            <Form.Input
                                validations="isLength:10"
                                type="tel"
                                validationErrors={{
                                    isDefaultRequiredValue: 'โปรดใส่เบอร์โทรศัพท์',
                                    isLength: 'โปรดใส่เบอร์โทรศัพท์ 10 หลัก'
                                }}
                                name="phone_number"
                                required
                                value={phone_number}
                                placeholder="เบอร์โทรศัพท์"
                                onChange={handleChange}
                                errorLabel={errorLabel}
                            />
                        </Form.Group>
                    )}
                    <Form.Group widths="equal" style={{marginTop: 15}}>
                        <Form.Input
                            required
                            name="address_1"
                            value={address_1}
                            icon="home"
                            iconPosition="left"
                            validationErrors={{
                                isDefaultRequiredValue: 'โปรดใส่เลขที่บ้าน ซอย เเละ ถนน '
                            }}
                            placeholder="กรุณาใส่เลขที่บ้าน ซอย เเละ ถนน"
                            onChange={handleChange}
                            errorLabel={errorLabel}
                        />
                    </Form.Group>
                    <Form.Group widths="3">
                        <Form.Select
                            required
                            name="province"
                            value={province}
                            onChange={handleChange}
                            options={this.generateAddressOption(ThaiAddress.provinces)}
                            placeholder="จังหวัด"
                        />
                        <Form.Select
                            required
                            name="district"
                            value={district}
                            onChange={handleChange}
                            options={this.generateAddressOption(
                                R.uniq(
                                    R.map(R.path(['city']), ThaiAddress.search({province}))
                                )
                            )}
                            placeholder="อำเภอ"
                        />
                        <Form.Select
                            required
                            name="sub_district"
                            value={sub_district}
                            onChange={handleChange}
                            options={this.generateAddressOption(
                                R.uniq(
                                    R.map(
                                        R.path(['tumbon']),
                                        ThaiAddress.search({city: district})
                                    )
                                )
                            )}
                            placeholder="ตำบล"
                        />
                    </Form.Group>
                    <Form.Group widths="2" style={{marginTop: 15}}>
                        <Form.Select
                            required
                            name="postal_code"
                            value={postal_code}
                            onChange={handleChange}
                            options={this.generateAddressOption(
                                R.uniq(
                                    R.map(
                                        R.path(['zipcode']),
                                        ThaiAddress.search({tumbon: sub_district})
                                    )
                                )
                            )}
                            placeholder="รหัสไปรษณีย์"
                        />
                        <Form.Select
                            reqruied
                            name="country"
                            value="Thailand"
                            options={countryOptions}
                            placeholder="ประเทศ"
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>
                <div style={{marginTop: 15}}>
                    <Button onClick={this.props.onClickBack}>ก่อนหน้า</Button>
                    <Button color="teal" form="mailing" type="submit">
                        ยืนยัน
                    </Button>
                </div>
            </React.Fragment>
        )
    }
}

export default MailingAddressPresentation



// WEBPACK FOOTER //
// /opt/build/repo/src/components/MailingAddress/index.js